// The app icon (same artwork as branding/icon.svg), usable at any size.
export function Logo({ size = 64, rounded = true }: { size?: number; rounded?: boolean }) {
  const rx = rounded ? 114 : 0;
  return (
    <svg width={size} height={size} viewBox="0 0 512 512" aria-hidden="true" className="logo">
      <defs>
        <linearGradient id="gcb-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#3A3A3A" />
          <stop offset="0.55" stopColor="#1A1A1A" />
          <stop offset="1" stopColor="#050505" />
        </linearGradient>
        <radialGradient id="gcb-sheen" cx="0.25" cy="0.15" r="0.75">
          <stop offset="0" stopColor="#fff" stopOpacity="0.22" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="gcb-cloud" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#FFFFFF" />
          <stop offset="1" stopColor="#BDBDBD" />
        </linearGradient>
        <linearGradient id="gcb-cursor" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#FFFFFF" />
          <stop offset="1" stopColor="#9A9A9A" />
        </linearGradient>
        <mask id="gcb-window">
          <rect width="512" height="512" fill="#fff" />
          <rect x="172" y="214" width="168" height="108" rx="18" fill="#000" />
          <circle cx="193" cy="234" r="5.5" fill="#fff" />
          <circle cx="209" cy="234" r="5.5" fill="#fff" />
          <circle cx="225" cy="234" r="5.5" fill="#fff" />
          <rect x="240" y="228" width="84" height="12" rx="6" fill="#fff" />
        </mask>
      </defs>
      <rect width="512" height="512" rx={rx} fill="url(#gcb-bg)" />
      <rect width="512" height="512" rx={rx} fill="url(#gcb-sheen)" />
      <g transform="translate(-2 22)">
        <path mask="url(#gcb-window)" fill="url(#gcb-cloud)" d="M144 352a72 72 0 0 1-8-143.5A112 112 0 0 1 352 180a88 88 0 0 1 16 172Z" />
        <g fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="7">
          <path d="M283.1 273.8A18 18 0 0 1 293.8 263.1" strokeOpacity="0.95" />
          <path d="M269.9 269.1A32 32 0 0 1 289.1 249.9" strokeOpacity="0.55" />
        </g>
        <path transform="translate(300 280) scale(1.12)" fill="url(#gcb-cursor)" stroke="#0A0A0A" strokeWidth="6" strokeLinejoin="round" d="M0 0V74L19 56L31 84L45 78L33 51H58Z" />
      </g>
    </svg>
  );
}
